import { apiClient } from "helpers/api_helper";

export const getAllCollectionData = async (data: object) => {
    try {
        const response = await apiClient.get(`/api/v1/Collection/GetAllCollection`, data);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
}